import React from "react";
import { ScrollView, ScrollViewProps } from "react-native";
import { RefreshControl } from "./RefreshControl";
import { useRefresh } from "../hooks/refresh";
import ScreenCardHeadband, { ScreenCardHeadbandProps } from "../screens/ScreenCardHeadband";

type SimplePageContentProps = {
    children: React.ReactNode;
    refresh?: () => Promise<unknown>;
    headband?: ScreenCardHeadbandProps;
} & ScrollViewProps;

const SimplePageContent = ({ children, refresh, headband, ...props }: SimplePageContentProps) => {
    const { localRefresh, refreshing } = useRefresh({ refresh });

    return (
        <ScrollView
            style={{ flex: 1 }}
            refreshControl={
                localRefresh && <RefreshControl onRefresh={localRefresh} refreshing={refreshing} />
            }
            {...props}
        >
            {headband && <ScreenCardHeadband {...headband} />}
            {children}
        </ScrollView>
    );
};

export default SimplePageContent;
